import { render, staticRenderFns } from "./about-menu.vue?vue&type=template&id=d73b5da4&scoped=true"
import script from "./about-menu.vue?vue&type=script&lang=js"
export * from "./about-menu.vue?vue&type=script&lang=js"
import style0 from "./about-menu.vue?vue&type=style&index=0&id=d73b5da4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d73b5da4",
  null
  
)

export default component.exports